// Tools → Book a Call Funnel Projections (Urban Unity; Tab for Joey Forslund, Nov 2 2026 6:07 PM ET). Sheets view only:
// "no need to have the projections tab, like the webinar revenue projector. Just have the sheets view" — so no Projections / Sheets
// switch, only components/CallFunnelProjectionSheets.tsx (Benchmarks & Actuals + Projection Calculator, the webinar sheet's layout).
import { CallFunnelProjectionSheets } from "../components/CallFunnelProjectionSheets";

export function BookCallProjections() {
  return (
    <div className="space-y-4" data-book-call-projections>
      <div className="mx-auto max-w-[1600px] pb-10">
        <p className="mb-3 text-xs font-bold uppercase tracking-[0.18em] text-[var(--brand-primary)]">Tools · Book a Call Funnel Projections · Sheets view</p>
        <CallFunnelProjectionSheets />
      </div>
    </div>
  );
}
